import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@ib-shared/shared.module';

import { DashboardAddDocumentModalComponent } from './components/add-document-modal/dashboard-add-document-modal.component';
import { DashboardBalancesComponent } from './components/balances/dashboard-balances.component';
import { DashboardCreditAccountModalComponent } from './components/credit-account-modal/dashboard-credit-account-modal.component';
import { DashboardComponent } from './components/dashboard.component';
import { DashboardTransactionsComponent } from './components/transactions/dashboard-transactions.component';
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
  imports: [CommonModule, SharedModule, DashboardRoutingModule],
  declarations: [
    DashboardComponent,
    DashboardTransactionsComponent,
    DashboardBalancesComponent,
    DashboardCreditAccountModalComponent,
    DashboardAddDocumentModalComponent,
  ],
})
export class DashboardModule {}
